/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCharterFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type Charter, type ProblemDetails } from '../models/index.js';
// @ts-ignore
import { CrewBriefingTemplatesRequestBuilderNavigationMetadata, CrewBriefingTemplatesRequestBuilderRequestsMetadata, type CrewBriefingTemplatesRequestBuilder } from './crewBriefingTemplates/index.js';
// @ts-ignore
import { GetCrewBriefingRequestBuilderRequestsMetadata, type GetCrewBriefingRequestBuilder } from './getCrewBriefing/index.js';
// @ts-ignore
import { GetDailyDeparturesRequestBuilderRequestsMetadata, type GetDailyDeparturesRequestBuilder } from './getDailyDepartures/index.js';
// @ts-ignore
import { GetFinancialDataRequestBuilderRequestsMetadata, type GetFinancialDataRequestBuilder } from './getFinancialData/index.js';
// @ts-ignore
import { CharterItemRequestBuilderNavigationMetadata, type CharterItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { type VipRequestBuilder, VipRequestBuilderRequestsMetadata } from './vip/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Charter
 */
export interface CharterRequestBuilder extends BaseRequestBuilder<CharterRequestBuilder> {
    /**
     * The CrewBriefingTemplates property
     */
    get crewBriefingTemplates(): CrewBriefingTemplatesRequestBuilder;
    /**
     * The GetCrewBriefing property
     */
    get getCrewBriefing(): GetCrewBriefingRequestBuilder;
    /**
     * The GetDailyDepartures property
     */
    get getDailyDepartures(): GetDailyDeparturesRequestBuilder;
    /**
     * The GetFinancialData property
     */
    get getFinancialData(): GetFinancialDataRequestBuilder;
    /**
     * The Vip property
     */
    get vip(): VipRequestBuilder;
    /**
     * Gets an item from the ApiSdk.Charter.item collection
     * @param charterId Unique identifier of the item
     * @returns {CharterItemRequestBuilder}
     */
     byCharterId(charterId: number) : CharterItemRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Charter[]>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     get(requestConfiguration?: RequestConfiguration<CharterRequestBuilderGetQueryParameters> | undefined) : Promise<Charter[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<CharterRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface CharterRequestBuilderGetQueryParameters {
    isArchived?: boolean;
}
/**
 * Uri template for the request builder.
 */
export const CharterRequestBuilderUriTemplate = "{+baseurl}/Charter{?isArchived*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CharterRequestBuilderNavigationMetadata: Record<Exclude<keyof CharterRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byCharterId: {
        navigationMetadata: CharterItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["charter%2Did"],
    },
    crewBriefingTemplates: {
        requestsMetadata: CrewBriefingTemplatesRequestBuilderRequestsMetadata,
        navigationMetadata: CrewBriefingTemplatesRequestBuilderNavigationMetadata,
    },
    getCrewBriefing: {
        requestsMetadata: GetCrewBriefingRequestBuilderRequestsMetadata,
    },
    getDailyDepartures: {
        requestsMetadata: GetDailyDeparturesRequestBuilderRequestsMetadata,
    },
    getFinancialData: {
        requestsMetadata: GetFinancialDataRequestBuilderRequestsMetadata,
    },
    vip: {
        requestsMetadata: VipRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const CharterRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: CharterRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createCharterFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
